var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4158_12099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.109 8.77063V0.606636C11.109 0.277737 11.3648 0 11.6937 0C16.2142 0 19.8796 3.66539 19.8796 8.18592C19.8796 8.51482 19.6019 8.77063 19.273 8.77063H11.109ZM1.16895 9.94005C1.16895 5.50723 4.46159 1.83818 8.73362 1.25347C9.06983 1.20596 9.35487 1.47639 9.35487 1.81625V10.5248L15.0741 16.2439C15.3189 16.4888 15.3006 16.8908 15.0192 17.0881C13.5867 18.1114 11.8326 18.7107 9.93958 18.7107C5.09746 18.7107 1.16895 14.7858 1.16895 9.94005ZM20.4059 10.5248C20.7457 10.5248 21.0125 10.8098 20.9687 11.146C20.6873 13.1888 19.7042 15.0051 18.268 16.3463C18.0488 16.5509 17.7052 16.5363 17.4933 16.3207L11.6937 10.5248H20.4059Z",
    fill: "#00A651"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4158_12099"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.0495V18.7107H0V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketShare);
export default __webpack_public_path__ + "static/media/market_share.ce7e662c06fbe01a1d85f5ef47a0a27d.svg";
export { ForwardRef as ReactComponent };